module.exports = __webpack_public_path__ + "img/20220106_102836 (1).5f14a766.jpg";